export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1570882676925-4d3fac25f94f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  advisoryTexture:
    "https://images.pexels.com/photos/7765115/pexels-photo-7765115.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
  founder:
    "https://images.unsplash.com/photo-1537344866510-1871f1c59b2b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};
